import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

const JST = 'Asia/Tokyo';

export const formatDate = (date: Date | string | null, format = 'YYYY/MM/DD'): string => {
  if (date) {
    return dayjs(date).format(format);
  }
  return '-';
};

// 実行環境のタイムゾーンに依存せず、常に日本時間 (JST) 基準で整形する。
// サーベイの開始日など「発行テナント基準 = JST」で表示すべき値に使う。
// （formatDate は実行環境のローカル TZ で整形するため、UTC 環境の CI と JST のローカルで結果がずれる）
export const formatDateJst = (date: Date | string | null, format = 'YYYY/MM/DD'): string => {
  if (date) {
    return dayjs(date).tz(JST).format(format);
  }
  return '-';
};
